import React, { useEffect, useRef, useState } from "react"
import { Container, Row, Col, } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { getRegularClasses, formatTime, formatFromTime, formaToTime, getInstructorDetailsWithSchedule } from '../Utils/utils';
import moment from "moment/moment";
import { makeStyles } from '@material-ui/core/styles';
import './style.css'
import DataTableExtensions from "react-data-table-component-extensions";
import tempJson from './temp.json'
import NotesModal from "../Components/Modals/NotesModal";
import SweetAlert from 'react-bootstrap-sweetalert';
import axios from "axios";
import config from "../config/config";
import { toast } from "react-toastify";
import SetupEditModal from "../Components/ClassesListing/SetupEditModal";
import WarningModal from "../Components/Modals/WarningModal";
import SuccessModal from "../Components/Modals/SuccessModal";
import LoadingSpinner from "../Components/LoadingSpinner";
import { normalTime, TimetoConvert } from "../Utils/TimeUtils";
import CustomSearch from "../Components/CustomSearch";


const ExpandedComponent = (props) => {
  const { data, setShowModal, setLangId, setSelectedRow, setCloseRow, setShowTime, setIsShow, setAvailableArray } = props;
  const [newArray, setNewArray] = useState([])
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    {
      name: 'Course No.',
      selector: row =>
      (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.serialized_course_number}
        </div>),
      sortable: false,
      width: '110px',

    },
    {
      id: 3,
      name: "Rank",
      cell: (row) =>
        <>
          <div className="row" style={{ fontSize: '12px' }}>
            <div className='cell-upper'>{row.RANK}</div>
          </div>
        </>,
      width: "80px",
    },
    {
      name: 'First Name',
      selector: row =>
      (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.FIRSTNAME}
        </div>
      ),
      sortable: false,
      width: '110px',
    },
    {
      name: 'Last Name',
      selector: row =>
      (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.LASTNAME}
        </div>
      ),
      sortable: false,
      width: '110px',
    },
    {
      name: 'Phone number',
      selector: row =>
      (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.PHONE}
        </div>
      ),
      sortable: false,
      width: '120px',

    },
    {
      name: 'Timezone',
      selector: row =>
      (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.TIMEZONE.includes('-') ? row.TIMEZONE.split('/')[0].trim() : row.TIMEZONE}
        </div>
      ),
      sortable: false,
      width: '160px',
    },
    {
      name: 'Availibility in EST',
      width: '355px',
      cell: (row) => <div>
        <table>
          <thead className="cell-head">
            <th>Mon</th>
            <th>Tue</th>
            <th>Wed</th>
            <th>Thur</th>
            <th>Fri</th>
            <th>Sat</th>
            <th>Sun</th>
          </thead>
          <tbody>
            <tr className="cell-row">
              <td>
                <div className="display-time">
                  {row?.MON_FROM ? <> {TimetoConvert(row?.MON_FROM, row?.MON_TO, row?.TIMEZONE)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.TUE_FROM ? <> {TimetoConvert(row?.TUE_FROM, row?.TUE_TO, row?.TIMEZONE)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.WED_FROM ? <> {TimetoConvert(row?.WED_FROM, row?.WED_TO, row?.TIMEZONE)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.THUR_FROM ? <> {TimetoConvert(row?.THUR_FROM, row?.THUR_TO, row?.TIMEZONE)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.FRI_FROM ? <> {TimetoConvert(row?.FRI_FROM, row?.FRI_TO, row?.TIMEZONE)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.SAT_FROM ? <> {TimetoConvert(row?.SAT_FROM, row?.SAT_TO, row?.TIMEZONE)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.SUN_FROM ? <> {TimetoConvert(row?.SUN_FROM, row?.SUN_TO, row?.TIMEZONE)}</> : ''}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>,
      sortable: false,
    },
    {
      name: 'Schedule in EST',
      width: '355px',
      cell: (row) => {
        const scheduleMap = row.selected_schedule
          .split('&&&')
          .filter(Boolean)
          .reduce((acc, schedule) => {
            const [day, startTime, endTime] = schedule.split(' - ');
            acc[day] = { startTime, endTime };
            return acc;
          }, {});

        return (
          <div>
            <table>
              <thead className="cell-head">
                <tr>
                  <th>Mon</th>
                  <th>Tue</th>
                  <th>Wed</th>
                  <th>Thu</th>
                  <th>Fri</th>
                  <th>Sat</th>
                  <th>Sun</th>
                </tr>
              </thead>
              <tbody>
                <tr className="cell-row">
                  {['MON', 'TUE', 'WED', 'THUR', 'FRI', 'SAT', 'SUN'].map((day) => {
                    const { startTime, endTime } = scheduleMap[day] || {};
                    return (
                      <td key={day}>
                        <div className="display-time">
                          <div>{startTime || ''}</div>
                          {startTime && endTime && <div>-</div>}
                          <div>{endTime || ''}</div>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </table>
          </div>
        );
      },
      sortable: false,
    },

    {
      name: 'Instructor',
      selector: row => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px',
        }}>
          {row.instructor_name}
        </div>
      ),
      sortable: false,
      width: '100px',
    },
    {
      name: 'Action',
      sortable: false,
      width: '150px',
      cell: (row) => <div className='cell-link'
      ><><i className="text-warning far fa-sticky-note mr-2" title="Notes"
        onClick={() => {
          props.setNotesShow(true)
          props.setNoteUserId(row?.LD_SID)
          props.setUserNote(row?.notes)
        }}
      ></i>
          <i className="text-danger fas fa-undo ml-3" title="Roll Back"
            onClick={() => {
              // props.setShowAlert(true)
              props.setStudentId(row?.id)
              setIsShow(true)
            }}
          ></i></></div>,
    },
  ];

  useEffect(() => {
    const copiedData = [...data.students];
    setNewArray(copiedData);
  }, [data.students]);

  const conditionalRowStyles = [
    {
      when: row => row.space_a_ind === 'T',
      style: {
        backgroundColor: '#fb6f46',
        color: 'black',
        '&:hover': {
          backgroundColor: '#FDB7A2 !important',
          cursor: 'pointer',
        },
      },
    }
  ];

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div style={{ transition: 'height 3s' }}>
        <DataTable
          columns={columns}
          data={newArray}
          conditionalRowStyles={conditionalRowStyles}

        />
        <Row className="w-100  mb-3 mt-2">
          <Col md={4}>
            <button
              className="btn btn-primary btn-xs mx-3"
              onClick={(e) => {
                var text = data?.selectedSchedule
                let match = text.split('matchedTimings')
                let newMatch = match[0].split('&&&')
                let newArr = []
                let newArrOther = []
                newMatch.map((a) => {
                  if (a !== "") {
                    let parts = a.split(" - ");
                    let classDay = parts[0];
                    let classTime = parts[1].replace(":", "") + "-" + parts[2].replace(":", "");

                    let dataValue = {
                      isSelected: true,
                      isConflictWithInstructor: false,
                      classDay: classDay,
                      classTime: classTime + 'EST'
                    }
                    newArr.push(a)
                    newArrOther.push(dataValue)
                  }
                })

                const selectedDays = newArrOther.map((arr) => arr.classDay);

                if (data.groupedSchedule != null) {
                  Object.entries(data.groupedSchedule).forEach(([day, time]) => {
                    if (!selectedDays.includes(day)) {
                      const fromStr = String(time.from);
                      const toStr = String(time.to);

                      let dataValue = {
                        isSelected: false,
                        isConflictWithInstructor: false,
                        classDay: day,
                        classTime: `${fromStr}-${toStr}EST`,
                      };

                      newArrOther.push(dataValue);
                    }
                  });
                }
                data.newMatchedTimings = newArrOther;
                props.setNewInstArr(newArr)
                setShowTime(false)
                setSelectedRow(data)
                setLangId(newArray[0]?.language.id)
                setShowModal(true)
                // let avalArr = []
                // const scheduleMap = newArray
                // console.log(data)
                // scheduleMap.map((a) => {
                //   if (a?.MON_FROM && !avalArr.find(a => a.startsWith('MON'))) {
                //     avalArr.push(`MON - ${TimetoConvert(a?.MON_FROM, a?.MON_TO, a?.TIMEZONE)}`)
                //   }
                //   if (a?.TUE_FROM && !avalArr.find(a => a.startsWith('TUE'))) {
                //     avalArr.push(`TUE - ${TimetoConvert(a?.TUE_FROM, a?.TUE_TO, a?.TIMEZONE)}`)
                //   }
                //   if (a?.WED_FROM && !avalArr.find(a => a.startsWith('WED'))) {
                //     avalArr.push(`WED - ${TimetoConvert(a?.WED_FROM, a?.WED_TO, a?.TIMEZONE)}`)
                //   }
                //   if (a?.THUR_FROM && !avalArr.find(a => a.startsWith('THUR'))) {
                //     avalArr.push(`THUR - ${TimetoConvert(a?.THUR_FROM, a?.THUR_TO, a?.TIMEZONE)}`)
                //   }
                //   if (a?.FRI_FROM && !avalArr.find(a => a.startsWith('FRI'))) {
                //     avalArr.push(`FRI - ${TimetoConvert(a?.FRI_FROM, a?.FRI_TO, a?.TIMEZONE)}`)
                //   }
                //   if (a?.SAT_FROM && !avalArr.find(a => a.startsWith('SAT'))) {
                //     avalArr.push(`SAT - ${TimetoConvert(a?.SAT_FROM, a?.SAT_TO, a?.TIMEZONE)}`)
                //   }
                //   if (a?.SUN_FROM && !avalArr.find(a => a.startsWith('SUN'))) {
                //     avalArr.push(`SUN - ${TimetoConvert(a?.SUN_FROM, a?.SUN_TO, a?.TIMEZONE)}`)
                //   }
                // })
                // setAvailableArray(avalArr)
              }
              }
            >
              View Schedule
            </button>
          </Col>

        </Row>
      </div >
    </>
  )
};

const ReadyGroup = (props) => {
  const [regualarClasses, setRegualarClasses] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [lang_id, setLangId] = useState('');
  const [isSetup, setIsSetup] = useState(false);
  const [closeRow, setCloseRow] = useState('');
  const [approvedArr, setApprovedArr] = useState([]);
  const [showTime, setShowTime] = useState(false);
  const [notesShow, setNotesShow] = useState(false);
  const [noteuserId, setNoteUserId] = useState('');
  const [userNote, setUserNote] = useState('');
  const [studentId, setStudentId] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [newInstArr, setNewInstArr] = useState([]);
  const [fromGrouped, setFromGrouped] = useState(1);
  const [isShow, setIsShow] = useState(false);
  const [isSuccessShow, setIsSuccessShow] = useState(false);
  const [isShow2, setIsShow2] = useState(false);
  const [isSuccessShow2, setIsSuccessShow2] = useState(false);
  const handleFilterChange = (e) => { setFilterText(e.target.value); };
  const [availableArray, setAvailableArray] = useState([]);

  const getAllRegularClasses = async () => {
    setIsLoading(true)
    setRegualarClasses(props.data)
    setIsLoading(false)
  }

  useEffect(() => {
    getAllRegularClasses()
  }, [props])

  const columns = [
    {
      name: 'Course Number',
      selector: row => `+ ${row.mainClassNumber}`,
      sortable: false,
    },
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL",
  };

  const useStyles = makeStyles(theme => ({
    root: {
      width: '50%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  }));

  const customStyles = {
    rows: {
      style: {
        minHeight: '72px',
        backgroundColor: '#cccccc',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        fontSize: '17px',
        fontWeight: 600,
        color: '#555555 !important',
      },
    },
  };

  const expandComp = (row, i) => {
    if (closeRow?.mainClassNumber == row?.mainClassNumber) {
      return false
    } else {
      return true
    }

  }
  const showSelectRow = (row) => {
    if (closeRow?.mainClassNumber == row?.mainClassNumber) {
      return true
    } else {
      return false
    }

  }
  const isRowSelectable = (row) => {
    // Your condition to disable row selection
    return row.isApproved == false ? true : false; // Replace with your condition
  };

  const onSubmit = async () => {
    var temp = []
    setIsLoading(true);

    approvedArr.map((a) => {
      var obj = {}
      var timee = (a.selectedSchedule).split('&&&')
      timee.map((d) => {
        if (d !== "") {
          var k = d.split('-')
          obj[k[0].trim()] = {
            "from": k[2].trim(),
            "to": k[2].trim()
          }
        }
      })
      temp.push({
        "mainClassNumber": a.mainClassNumber,
        "selectedSchedule": obj,
        "language": a.language,
        "availableStartDate": a.availableStartDate,
        "availableEndDate": a.availableEndDate,
        "students": a.students,
        "generatedHash": a.generatedHash,
        "instructorAccepted": a.instructorAccepted,
        "instructorEmail": a.instructorEmail,
        "instructorId": a.instructorId,
        "instructorName": a.instructorName,
        "isApproved": a.isApproved,
        "isFlex": a.isFlex,
        "isReady": a.isReady,
        "isReadyToApprove": a.isReadyToApprove,
        "isTimesSetup": a.isTimesSetup
      })
    })
    var token = localStorage.getItem('access_token');
    let path = config.siteUrl;
    await axios.post(path + '/classes/send-sou', {
      data: temp
    }, {
      headers: { 'content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
        // console.log(response,"send sou.....")
        if (response.data.status == 200) {
          setIsSuccessShow2(true)
          setIsLoading(false);
          // toast.success(response.data.message)
          // let aprArr = []
          // approvedArr.map((apr) => {
          //   aprArr.push(apr.mainClassNumber)
          // })
          // const filteredArray = regualarClasses.filter(item => !aprArr.includes(item.mainClassNumber));
          // setRegualarClasses(filteredArray)
        }
      })
      .catch((error) => {
        console.log(error)
        setIsLoading(false);
      });
    // console.log(temp, "././././teememememem")
  }

  const removeStudent = async (id) => {
    var token = localStorage.getItem('access_token');
    let path = config.siteUrl;
    await axios.post(path + '/classes/rollback-student', {
      id: id
    }, {
      headers: { 'content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
        // toast.success(response.data.message)
        setShowAlert(false)
        setIsShow(false)
        setIsSuccessShow2(true)
        props.setRecallApi(true)
      })
      .catch((error) => {
        console.log(error)
      });
  }
  const onProceed = async () => {
    removeStudent(studentId)
  }
  const onProceed2 = () => {
    setIsShow2(false)
    onSubmit()
  }
  const onClose = () => {
    setIsSuccessShow2(false)
    let aprArr = []
    approvedArr.map((apr) => {
      aprArr.push(apr.mainClassNumber)
    })
    const filteredArray = regualarClasses.filter(item => !aprArr.includes(item.mainClassNumber));
    setRegualarClasses(filteredArray)
  }

  const onSubmitSave = async () => {


    const selectedScheduleData = selectedRow.newMatchedTimings
      .filter(item => item.isSelected)  // Keep only selected items
      .reduce((acc, item) => {
        const [from, to] = item.classTime.replace('EST', '').split('-');  // Extract time without EST
        acc[item.classDay] = { from, to };
        return acc;
      }, {});

    var temp = []
    temp.push({
      "mainClassNumber": selectedRow.mainClassNumber,
      "matchedTimings": selectedRow.groupedSchedule,
      "selectedSchedule": selectedScheduleData,
      "matchedIn": [],
      "language": selectedRow.language,
      "availableStartDate": selectedRow.availableStartDate,
      "students": selectedRow.students,
      "generatedHash": selectedRow.generatedHash,
      "instructorAccepted": selectedRow.instructorAccepted,
      "instructorEmail": selectedRow.instructorEmail,
      "instructorId": selectedRow.instructorId,
      "instructorName": selectedRow.instructorName,
      "isApproved": selectedRow.isApproved,
      "isFlex": selectedRow.isFlex,
      "isReady": selectedRow.isReady,
      "isReadyToApprove": selectedRow.isReadyToApprove,
      "isTimesSetup": selectedRow.isTimesSetup
    })

    // console.log(temp);
    var token = localStorage.getItem('access_token');
    let path = config.siteUrl;
    await axios.post(path + '/classes/group-raw-data', {
      data: temp
    }, {
      headers: { 'content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
        props.setRecallApi(true)

      })
      .catch((error) => {
        console.log(error)
      });
  }


  const onProceedSave = async () => {
    setShowModal(false)
    onSubmitSave()
  }



  const getInstructorDetail = async () => {
    const res = await getInstructorDetailsWithSchedule(
      selectedRow?.instructorId,
      selectedRow?.language?.id,
      selectedRow?.newMatchedTimings,
      selectedRow?.mainClassNumber,
      selectedRow?.availableStartDate
    );
    console.log(res, "getInstructorDetail res...");
  };






  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div>
        <div className="row mb-4 mt-3">
          <div className="col-md-12">
            {regualarClasses.length > 0 ?
              <div className="card m-overflow-h todo-card-list" style={{ border: 'none' }}>
                <div className='top-row'>
                  <div className="row">
                    <div className="col-lg-9" style={{ display: 'flex', alignItems: 'center' }}>
                      <div className='heading-text'>
                        Group Classes
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <CustomSearch filterText={filterText} onFilter={handleFilterChange} />
                    </div>
                  </div>
                </div>
                <div className="card-body m-p-0 p-0">
                  <DataTableExtensions
                    columns={columns}
                    data={
                      regualarClasses.filter((item) =>
                        Object.values(item).some((value) =>
                          String(value).toLowerCase().includes(filterText.toLowerCase().trim())
                        ) ||
                        (item.students &&
                          item.students.some((student) =>
                            Object.values(student).some((studentValue) =>
                              String(studentValue).toLowerCase().includes(filterText.toLowerCase().trim())
                            )
                          ))
                      )
                    }
                    print={false}
                    export={false}
                    filter={false}
                  >
                    <DataTable
                      expandableRows
                      expandableRowExpanded={(row) => expandComp(row)}
                      expandableRowsComponent={ExpandedComponent}
                      pagination
                      expandOnRowClicked
                      selectableRows
                      expandableRowsComponentProps={{
                        "setShowModal": setShowModal,
                        "setLangId": setLangId,
                        "setSelectedRow": setSelectedRow,
                        "setCloseRow": setCloseRow,
                        "setShowTime": setShowTime,
                        "setNotesShow": setNotesShow,
                        "setNoteUserId": setNoteUserId,
                        "setUserNote": setUserNote,
                        "setStudentId": setStudentId,
                        "setShowAlert": setShowAlert,
                        "setNewInstArr": setNewInstArr,
                        "setIsShow": setIsShow,
                        "setAvailableArray": setAvailableArray
                      }}
                      onSelectedRowsChange={({ selectedRows }) => {
                        setApprovedArr(selectedRows)
                      }}
                      paginationPerPage={10}
                      paginationRowsPerPageOptions={[10, 25, 50, 100]}
                      selectableRowDisabled={isRowSelectable}
                      noTableHead={true}
                      expandableRowsHideExpander={true}
                      customStyles={customStyles}
                      className="custom-table-border"
                    />
                  </DataTableExtensions>

                  <Row className="w-100 display-center mt-5">
                    <div className="btn-box-2">
                      <div className="main-btn" onClick={() => {
                        if (approvedArr.length > 0) {
                          setIsShow2(true)
                        } else {
                          toast.error('Please select classes')
                        }
                      }} >
                        Send SOU
                      </div>
                    </div>
                  </Row>
                </div>
              </div>
              :
              <div className="no-record">
                There are no records to display.
              </div>
            }
          </div>
        </div>
      </div>
      {notesShow == true ?
        <NotesModal
          notesShow={notesShow}
          setNotesShow={setNotesShow}
          noteUserId={noteuserId}
          userNote={userNote}
          setNoteNew={props.setNoteNew}
        />
        : null}
      {showModal == true ?
        <SetupEditModal
          showModal={showModal}
          setShowModal={setShowModal}
          lang_id={lang_id}
          setIsSetup={setIsSetup}
          setCloseRow={setCloseRow}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          closeRow={closeRow}
          showTime={showTime}
          newInstArr={newInstArr}
          fromGrouped={fromGrouped}
          availableArray={availableArray}
          onProceed={onProceedSave}
        />
        : null}
      {isShow == true ?
        <WarningModal
          isShow={isShow}
          setIsShow={setIsShow}
          onProceed={onProceed} />
        : null}
      {isSuccessShow == true ?
        <SuccessModal
          isSuccessShow={isSuccessShow}
          setIsSuccessShow={setIsSuccessShow} />
        : null}
      {isShow2 == true ?
        <WarningModal
          isShow={isShow2}
          setIsShow={setIsShow2}
          onProceed={onProceed2} />
        : null}
      {isSuccessShow2 == true ?
        <SuccessModal
          isSuccessShow={isSuccessShow2}
          setIsSuccessShow={setIsSuccessShow2}
          onClose={onClose}
        />
        : null}
    </>
  )
}
export default ReadyGroup